import { render, staticRenderFns } from "./DepthChartV2.vue?vue&type=template&id=10fdc031&scoped=true&"
import script from "./DepthChartV2.vue?vue&type=script&lang=ts&"
export * from "./DepthChartV2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fdc031",
  null
  
)

export default component.exports